import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { StepProps } from '../../types';
import { useStyles } from './styles';
import { Markdown } from '../../../../components';
import { Model3D } from '../Model3D';
import { useTranslate } from '../../../../translations';

export const Step: React.FC<StepProps> = ({ step, headerHeight = 0, currentCarouselIndex }) => {
  const styles = useStyles();
  const t = useTranslate();
  const [arButtonKey, setArButtonKey] = useState(0);

  // https://www.figma.com/file/wtmeA5cIV3UCuSfR1BdkAS/AR?node-id=100%3A2064&t=MwgNAyicKcwPEnZ6-4
  const modelHeight = `calc((100vh - ${headerHeight}px) * 0.7)`;
  const contentMinHeight = `calc(100vh - ${headerHeight}px)`;

  useEffect(() => {
    // an attempt for fix https://pizzahutinternational.atlassian.net/browse/HBAR-62
    // force rerender of button may help
    setArButtonKey(prev => prev + 1);
  }, [currentCarouselIndex]);

  return (
    <Box sx={{ minHeight: contentMinHeight }}>
      <Box
        sx={{
          height: modelHeight,
        }}>
        <Model3D
          src={step.ar.src}
          srcIos={step.ar.srcIos}
          title={t(step.titleKey, { defaultValue: step.title })}
          arButtonKey={arButtonKey}
        />
      </Box>
      <Box className={styles.textContainer}>
        <Typography variant="subtitle2">{t(step.titleKey, { defaultValue: step.title })}</Typography>
        <Markdown className={styles.description}>{t(step.descriptionKey, { defaultValue: step.description })}</Markdown>
      </Box>
    </Box>
  );
};
